import { AxiosError, AxiosResponse, isAxiosError } from "axios";
import { debugConsole } from "utilz/helpers";
class APIRequestError extends Error {
  traceId: string;
  status: number;
  data?: any;
  constructor(message: string, traceId: string, status: number, data?: any) {
    super(message);
    this.name = "APIRequestError";
    this.traceId = traceId;
    this.status = status;
    this.data = data;
  }
}
export const apiErrorHandler = (error: AxiosError | AxiosResponse) => {
  let errorData: {
    traceId: string;
    message: string;
    status: number;
    data: any;
  } = {
    traceId: "",
    message: "",
    status: 200,
    data: null,
  };
  if (isAxiosError(error)) {
    const resData = error.response?.data as any;
    errorData = {
      traceId: error.response?.headers?.["x-request-id"] || "",
      message: resData?.message || error?.message || "",
      status: error.response?.status || 0,
      data: resData || null,
    };
  } else {
    errorData = {
      traceId: error.headers?.["x-request-id"] || "",
      message: error.data?.message,
      status: error.data?.statusCode || 0,
      data: error.data?.data,
    };
  }

  debugConsole("🚀 ~ errorData", errorData);
  throw new APIRequestError(
    errorData.message,
    errorData.traceId,
    errorData.status,
    errorData.data
  );
};
